export default {
  title: 'Tem a certeza de que quer eliminar a sua conta?',
  description:
    'Esta ação é permanente. Perderá o acesso às suas encomendas, pontos de fidelidade e preferências guardadas.',
  labels: {
    loading: 'A eliminar a sua conta…',
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  toasts: {
    success:
      'A sua conta foi eliminada permanentemente. Já não tem acesso ao seu histórico de encomendas, pontos de fidelidade ou dados guardados.',
    error:
      'Algo correu mal. Tente novamente. Se o problema persistir, contacte a nossa equipa de suporte: {{supportEmail}}',
  },
};
